module.exports = __webpack_public_path__ + "img/jp_logistics_banner.fa27600.jpg";